import "./styles.scss";
import React from "react";
import { ReactComponent as UpDownIcon } from "../../../../assets/images/up-down-icon.svg";
import { ReactComponent as UpDownIcon2 } from "../../../../assets/images/up-down-icon_v1.svg";

interface TypeEntryButton {
  onClick: () => void;
  direction?: string;
  children?: any;
  operatorId?: number;
}

const EntryButton: React.FC<TypeEntryButton> = ({
  onClick,
  children,
  direction = "below",
  operatorId,
}) => {
  return (
    <button className={`entry-button ${direction}`} onClick={onClick}>
      {direction === "below" && (
        <div className={`wrap-content-${direction}`}>{children}</div>
      )}
      {operatorId === 2 ? <UpDownIcon2 /> : <UpDownIcon />}
      {direction !== "below" && (
        <div className={`wrap-content-${direction}`}>{children}</div>
      )}
    </button>
  );
};

export default EntryButton;
